import { render, staticRenderFns } from "./EditPublicProfile.vue?vue&type=template&id=684bb93e&scoped=true"
import script from "./EditPublicProfile.vue?vue&type=script&lang=js"
export * from "./EditPublicProfile.vue?vue&type=script&lang=js"
import style0 from "./EditPublicProfile.vue?vue&type=style&index=0&id=684bb93e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684bb93e",
  null
  
)

export default component.exports